// client/src/components/marketer/project/modals/ConfirmModal.js
import React from 'react';
import '../../../../styles/marketer/modals/ConfirmModal.css';

export default function ConfirmModal({ open, onClose, onConfirm, title, message }) {
  if (!open) return null;

  return (
    <div className="confirm-modal mbm-overlay">
      <div className="confirm-modal__content mbm">
        <div className="confirm-modal__header">
          <div className="mbm-head">
            <div className="confirm-modal__title mbm-title">{title || '확인'}</div>
            <button type="button" onClick={onClose} aria-label="close" className="mbm-close">×</button>
          </div>
          <div className="confirm-modal__message">{message}</div>
        </div>
        <div className="confirm-modal__actions mbm-foot">
          <button
            type="button"
            onClick={onClose}
            className="mb-btn mb-btn-secondary"
          >
            취소
          </button>
          <button
            type="button"
            onClick={() => {
              onConfirm();
              onClose();
            }}
            className="mb-btn mb-btn-primary"
          >
            확인
          </button>
        </div>
      </div>
    </div>
  );
}

